import React, { useState } from "react";
import Card from "../UI/Card";
import ExpensesChart from "./ExpensesChart";
import ExpensesFilter from "./ExpensesFilter";
import ExpensesList from "./ExpensesList";
import "./NewExpense.css";

const NewExpense = ({ expenses }) => {
  const [year, setYear] = useState("2021");

  const onHandleChange = (selectedYear) => {
    setYear(selectedYear);
    // console.log('From NewExpenses Component');
  };

  const filteredYear = expenses.filter((expense) => {
    return expense.date.getFullYear().toString() === year;
  });

  return (
    <div>
      <Card className="expenses">
        <ExpensesFilter year={year} onHandleChange={onHandleChange} />
        <ExpensesChart expenses={filteredYear} />
        <ExpensesList items={filteredYear} />
      </Card>
    </div>
  );
};

export default NewExpense;
